import { Box, SxProps, Theme } from '@mui/material';
import React from 'react';
import { ColorDTO, colorDtoToHex } from '@model/dynamicTimeTable/ColorDTO';

interface ColorOptionSwatchProps {
  color: ColorDTO;
  sx?: SxProps<Theme>;
}

export const ColorOptionSwatch = ({ color, sx }: ColorOptionSwatchProps) => (
  <Box
    sx={{
      width: 110,
      height: 24,
      backgroundColor: `${colorDtoToHex(color)} !important`,
      border: '1px solid #ccc',
      borderRadius: 1,
      ...sx,
    }}
  />
);
